//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ResponsePaymentGeneral, Tarjeta } from "../../types/common";



//-------------------------------------------------------------------------------------------------- Interfaces
interface ContractDataInterface {
    clientId: string;
    paymentData: ResponsePaymentGeneral;
    recurrentCard: Tarjeta | null;
};

interface PaymentDataSliceInterface {
    contracts: Array<ContractDataInterface>;
};



//-------------------------------------------------------------------------------------------------- Vars and constants
const paymentDataSliceInitialState = {
    contracts: []
} as PaymentDataSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const paymentDataSlice = createSlice({
    name: "paymentData",
    initialState: paymentDataSliceInitialState,
    reducers: {
        setPaymentData: (state, action: PayloadAction<PaymentDataSliceInterface>) => {
            state.contracts = action.payload.contracts;
        },
        setPaymentDataToContract: (state, action: PayloadAction<ContractDataInterface>) => {
            const contractIndex = state.contracts.findIndex(
                obj => obj.clientId === action.payload.clientId
            );

            if (contractIndex >= 0) {
                state.contracts[contractIndex].paymentData = action.payload.paymentData;
                state.contracts[contractIndex].recurrentCard = action.payload.recurrentCard;
            }
            else {
                state.contracts.push(action.payload);
            }
        },
        clearPaymentData: (state) => {
            state.contracts = paymentDataSliceInitialState.contracts;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const { setPaymentData, setPaymentDataToContract, clearPaymentData } = paymentDataSlice.actions;
export const getPaymentDataContracts = (state: any) => state.paymentData as PaymentDataSliceInterface;
export default paymentDataSlice.reducer;
